module.exports = require("body-parser");


//////////////////
// WEBPACK FOOTER
// external "body-parser"
// module id = 237
// module chunks = 0